if (!customElements.get("ai-review-summary-keyword")) {
  class AIReviewSummaryKeyword extends HTMLElement {
    constructor() {
      super();
      this.isMobile = window.matchMedia("(max-width: 749px)").matches;
      this._onClick = this._onClick.bind(this);
      this._onResize = this._onResize.bind(this);
    }

    connectedCallback() {
      this.overlay = this.querySelector(".ai-popup-overlay");
      this.popup = this.querySelector(".ai-popup");
      this.closeBtn = this.querySelector(".ai-popup-close");

      this.keywordsContainer = this.querySelector(".ai-keywords-list");
      this.popupKeywordsContainer = this.querySelector(".ai-popup-keywords");

      this.desktopKeywordContainer = this.querySelector(".ai-keywords-container--content");
      this.desktopKeywordDetails = this.querySelector(".ai-keyword-details");

      if (this.desktopKeywordDetails) this.desktopKeywordDetails.classList.add("hidden");

      this.addEventListener("click", this._onClick);

      this._overlayClick = () => this.closePopup();
      this._closeBtnClick = () => this.closePopup();

      if (this.overlay) this.overlay.addEventListener("click", this._overlayClick);
      if (this.closeBtn) this.closeBtn.addEventListener("click", this._closeBtnClick);

      window.addEventListener("resize", this._onResize);

      this.loadSummaryAPI();

      if (this.popup && this.closeBtn) {
        this.popupResizeObserver = new ResizeObserver(() =>
          this.positionCloseButton()
        );
        this.popupResizeObserver.observe(this.popup);
      }
    }

    disconnectedCallback() {
      this.removeEventListener("click", this._onClick);
      if (this.overlay) this.overlay.removeEventListener("click", this._overlayClick);
      if (this.closeBtn) this.closeBtn.removeEventListener("click", this._closeBtnClick);
      window.removeEventListener("resize", this._onResize);
      if (this.popupResizeObserver) {
        this.popupResizeObserver.disconnect();
      }
    }

    encode(str) {
      return str.replace(/&/g, "&amp;").replace(/"/g, "&quot;");
    }

    decode(str) {
      return str.replace(/&quot;/g, '"').replace(/&amp;/g, "&");
    }

    async loadSummaryAPI() {
      const pid = this.dataset.productId;
      this.summaryContainer = this.querySelector(".ai-summary-container--content");
      this.summaryEl = this.summaryContainer?.querySelector(".ai-summary-text");
      this.reviewStarsContainer = this.querySelector(".review-stars-container");

      if (!pid || !this.summaryEl) return;

      this.summaryEl.textContent = "Generating summary…";

      const url = `https://hyphenaireview.letshyphen.com/api/product/${pid}/summary?refresh=false`;

      try {
        const res = await fetch(url, {
          method: "GET",
          headers: {
            "accept": "application/json",
            "Authorization": "0d059f813889a003ff6c0134fe6d0c1e7f71a2a6ddfdfbf50af35ac756d2a4"
            
          }
        });
        const data = await res.json();

        if (this.reviewStarsContainer && this.dataset.judgemeRatingStar && this.dataset.judgemeRatingCount) {
          const avgRating = parseFloat(this.dataset.judgemeRatingStar || 0).toFixed(1);
          const totalReviews = Number(this.dataset.judgemeRatingCount || 0).toLocaleString();

          const fullStarSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M20 7.3534L12.7329 6.87562L9.99602 0L7.25918 6.87562L0 7.3534L5.56773 12.081L3.7407 19.2524L9.99602 15.2985L16.2514 19.2524L14.4243 12.081L20 7.3534Z" fill="#FFCE31"/>
          </svg>`;
          const halfStarSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
            <g clip-path="url(#clip0_1430_4532)">
            <path d="M20.625 7.7284L13.3579 7.25062L10.621 0.375L7.88418 7.25062L0.625 7.7284L6.19273 12.456L4.3657 19.6274L10.621 15.6735L16.8764 19.6274L15.0493 12.456L20.625 7.7284Z" fill="#FFCE31"/>
            </g>
            <g clip-path="url(#clip1_1430_4532)">
            <path d="M12.8936 7.43555L13.0098 7.72852L13.3252 7.75L19.3574 8.14551L14.7256 12.0742L14.4873 12.2764L14.5645 12.5791L16.0811 18.5332L10.8877 15.251L10.6211 15.082L10.3535 15.251L5.16016 18.5332L6.67773 12.5791L6.75391 12.2773L6.5166 12.0752L1.88867 8.14648L7.91699 7.75L8.23242 7.72852L8.34863 7.43555L10.6211 1.72656L12.8936 7.43555Z" stroke="#FFCE31"/>
            </g>
            <defs>
            <clipPath id="clip0_1430_4532">
            <rect width="11" height="20" fill="white"/>
            </clipPath>
            <clipPath id="clip1_1430_4532">
            <rect width="11" height="20" fill="white" transform="translate(10)"/>
            </clipPath>
            </defs>
          </svg>`;
          const emptyStarSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M12.2686 7.06055L12.3848 7.35352L12.7002 7.375L18.7324 7.77051L14.1006 11.6992L13.8623 11.9014L13.9395 12.2041L15.4561 18.1582L10.2627 14.876L9.99609 14.707L9.72852 14.876L4.53516 18.1582L6.05273 12.2041L6.12891 11.9023L5.8916 11.7002L1.26367 7.77148L7.29199 7.375L7.60742 7.35352L7.72363 7.06055L9.99609 1.35156L12.2686 7.06055Z" stroke="#FFCE31"/>
          </svg>`;

          let starsHTML = "";
          const fullStars = Math.floor(avgRating);
          const halfStar = avgRating % 1 >= 0.5;
          for (let i = 0; i < 5; i++) {
            if (i < fullStars) starsHTML += fullStarSVG;
            else if (i === fullStars && halfStar) starsHTML += halfStarSVG;
            else starsHTML += emptyStarSVG;
          }

          this.reviewStarsContainer.innerHTML = `
            <div class="stars-rating">${starsHTML} <span class="star-ratings-text">${avgRating} out of 5 stars</span></div>
            <div class="total-ratings">${totalReviews} global ratings</div>
          `;
        }

        const totalReviewsCount = Number(data.total_reviews || 0);
        if (totalReviewsCount < 10) {
          if (this.summaryContainer) this.summaryContainer.classList.add("hidden");
          if (this.desktopKeywordContainer) this.desktopKeywordContainer.classList.add("hidden");
          if (this.keywordsContainer) this.keywordsContainer.innerHTML = "";
          if (this.popupKeywordsContainer) this.popupKeywordsContainer.innerHTML = "";
          if (this.desktopKeywordDetails) this.desktopKeywordDetails.classList.add("hidden");
          return;
        }

        if (data.summary) {
          this.summaryEl.textContent = data.summary;
          this.summaryContainer?.classList.remove("hidden");
        } else {
          this.summaryContainer?.classList.add("hidden");
        }

        let keywords = Array.isArray(data.keywords) ? data.keywords : [];
        const customKeywords = this.dataset.keywords;   
        if (customKeywords) {
          const kwArr = customKeywords.split(",").map(k => k.trim()).filter(Boolean);
          if (kwArr.length) keywords = kwArr;
        }

        if (this.keywordsContainer) this.keywordsContainer.innerHTML = "";
        if (this.popupKeywordsContainer) this.popupKeywordsContainer.innerHTML = "";

        const iconHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
            <g clip-path="url(#clip0_2838_279)">
              <path d="M4.76336 7.23053C4.70076 7.29773 4.60036 7.31313 4.52016 7.26893L0.87856 5.25333C0.82376 5.22293 0.77076 5.21013 0.72156 5.21013C0.62376 5.21013 0.54096 5.26053 0.48656 5.32253C0.40456 5.41593 0.35076 5.58173 0.46896 5.74173L4.63796 11.3827C4.74716 11.5303 4.91476 11.6093 5.09396 11.5989C5.27536 11.5885 5.43256 11.4911 5.52476 11.3313L11.5496 0.902731C11.66 0.711731 11.5706 0.548931 11.4608 0.467531C11.3512 0.386531 11.183 0.354331 11.04 0.507331L4.76336 7.23053Z" fill="#02AC99"/>
            </g>
            <defs>
              <clipPath id="clip0_2838_279">
                <rect width="12" height="12" fill="white"/>
              </clipPath>
            </defs>
          </svg>`;

        keywords.forEach(kw => {
          const desktopHTML = `
            <div class="ai-keyword-item" data-keyword="${kw}">
              <span class="ai-keyword-icon">${iconHTML}</span>
              <button class="ai-keyword" data-keyword="${kw}">${kw}</button>
            </div>
          `;
          const popupHTML = `
            <div class="ai-keyword-item" data-keyword="${kw}">
              <span class="ai-keyword-icon">${iconHTML}</span>
              <button class="ai-keyword-popup" data-keyword="${kw}">${kw}</button>
            </div>
          `;

          if (this.keywordsContainer) this.keywordsContainer.insertAdjacentHTML("beforeend", desktopHTML);
          if (this.popupKeywordsContainer) this.popupKeywordsContainer.insertAdjacentHTML("beforeend", popupHTML);
        });

        if (keywords.length > 0) {
          if (this.desktopKeywordContainer) this.desktopKeywordContainer.classList.remove("hidden");
        }
        else {
          if (this.desktopKeywordContainer) this.desktopKeywordContainer.classList.add("hidden");
        }
      } catch (err) {
        console.error("Summary API Error:", err);
        this.summaryEl.textContent = "Summary not available.";
      }
    }

    _onResize() {
      const wasMobile = this.isMobile;
      this.isMobile = window.matchMedia("(max-width: 749px)").matches;

      if (this.isMobile !== wasMobile) this.handleReadMore();
      if (this.isMobile) this.positionCloseButton();
    }

    _onClick(e) {
      const item = e.target.closest(".ai-keyword-item, .ai-keyword, .ai-keyword-popup");
      if (!item) return;

      const kw = item.dataset.keyword;
      if (!kw) return;

      const isPopup = this.popupKeywordsContainer && this.popupKeywordsContainer.contains(item);

      //Event Track here
      const reviewList = this.querySelector(".ai-keywords-list");
      const page = reviewList?.getAttribute("data-page") || "";
      const prdname = reviewList?.getAttribute("data-prdname") || "";

      if (window.clevertap?.event) {
        clevertap.event.push("section_clicked", {
          section_name: "ai_review_section",
          page: page,
          product_name: prdname,
          review_keyword: kw
        });
      }

      if (this.isMobile) {
        if (!isPopup) this.openPopup(kw);
        else {
          this.setActiveKeywordMobile(kw);
          requestAnimationFrame(() => this.scrollKeywordIntoView(kw));
        }
      } else {
        this.setActiveKeywordDesktop(kw);
        if (this.desktopKeywordDetails) this.desktopKeywordDetails.classList.remove("hidden");
      }

      this.updateKeywordReviews(kw);
    }

    async updateKeywordReviews(keyword) {
      if (!keyword) return;

      const pid = this.dataset.productId;
      if (!pid) return;

      const url = `https://hyphenaireview.letshyphen.com/api/product/${pid}/sentiment?keyword=${encodeURIComponent(keyword)}&force=false`;

      const allReviewLists = this.querySelectorAll(".ai-reviews-list");
      if (!this.isMobile) {
        allReviewLists.forEach(list => {
          list.innerHTML = `<div class="ai-review-loading">Loading reviews...</div>`;
        });
        this.desktopKeywordDetails.classList.add("hidden");
      }

      try {
        const res = await fetch(url, {
          headers: {
            "accept": "application/json",
            "Authorization": "0d059f813889a003ff6c0134fe6d0c1e7f71a2a6ddfdfbf50af35ac756d2a4"
          }
        });

        const data = await res.json();

        if (data.generating) {
          if (!this.isMobile) {
            allReviewLists.forEach(list => {
              list.innerHTML = `<div class="ai-review-loading">Generating reviews…</div>`;
            });
            this.desktopKeywordDetails.classList.remove("hidden");
          }
        }

        const pos = data.total_sentiment_count?.positive || 0;
        const neg = data.total_sentiment_count?.negative || 0;

        this.querySelectorAll(".ai-review-counts--total-count").forEach(el => el.textContent = pos + neg);
        this.querySelectorAll(".ai-review-counts--positive-count").forEach(el => el.textContent = pos);
        this.querySelectorAll(".ai-review-counts--negative-count").forEach(el => el.textContent = neg);

        const reviews = [...(data.positiveReviews || []), ...(data.negativeReviews || [])].slice(0, 10);

        const reviewHTML = reviews.map(r => {
          const fullText = r.text || "";
          const highlight = r.highlighted_text || fullText;

          const isShort = fullText.length < 180;

          let displayText = isShort ? fullText : this.buildTruncatedText(fullText, highlight);
          const needsReadMore = !isShort && fullText.length > displayText.length;

          return `
            <div class="ai-review">
              <p class="ai-review-text"
                data-full="${this.encode(fullText)}"
                data-highlight="${this.encode(highlight)}"
                data-short="${isShort}">
                ${displayText}
              </p>
              <button class="read-toggle ${needsReadMore ? "" : "hidden"}">Read more ›</button>
            </div>
          `;
        }).join("");

        allReviewLists.forEach(list => list.innerHTML = reviewHTML);
        this.desktopKeywordDetails.classList.remove("hidden");

        this.handleReadMore();

      } catch (err) {
        console.error("Error fetching keyword reviews:", err);
      }
    }

    buildTruncatedText(fullText, highlight) {
      if (!fullText || !highlight) return highlight;
      const fullNorm = fullText.toLowerCase().replace(/\s+/g, " ").trim();
      const highNorm = highlight.toLowerCase().replace(/\s+/g, " ").trim();
      const index = fullNorm.indexOf(highNorm);

      if (index !== -1) {
        const before = index > 0;
        const after = index + highNorm.length < fullNorm.length;
        if (before && after) return "..." + highlight + "...";
        if (before) return "..." + highlight;
        if (after) return highlight + "...";
        return highlight;
      }
      return "..." + highlight + "...";
    }

    handleReadMore() {
      this.querySelectorAll(".ai-review").forEach(review => {
        const textEl = review.querySelector(".ai-review-text");
        const toggle = review.querySelector(".read-toggle");
        if (!textEl || !toggle) return;

        const fullText = this.decode(textEl.dataset.full);
        const highlight = this.decode(textEl.dataset.highlight);
        const isShort = textEl.dataset.short === "true";

        if (isShort) {
          textEl.innerHTML = fullText;
          toggle.classList.add("hidden");
          return;
        }

        const startIndex = fullText.indexOf(highlight);
        const endIndex = startIndex + highlight.length;
        let shortText = highlight;
        const before = startIndex > 0;
        const after = endIndex < fullText.length;

        if (before && after) shortText = "..." + highlight + "...";
        else if (before) shortText = "..." + highlight;
        else if (after) shortText = highlight + "...";

        textEl.innerHTML = shortText;
        toggle.classList.toggle("hidden", fullText.length <= highlight.length);

        toggle.addEventListener("click", () => {
          const expanded = textEl.classList.toggle("expanded");
          textEl.innerHTML = expanded ? fullText : shortText;
          toggle.textContent = expanded ? "Read less ›" : "Read more ›";
        });
      });
    }

    openPopup(keyword) {
      if (!this.popup || !this.isMobile) return;
      document.body.style.overflow = "hidden";
      this.popup.classList.add("active");
      if (this.overlay) this.overlay.classList.add("active");
      if (this.closeBtn) this.closeBtn.classList.add("active");

      const duration = parseFloat(getComputedStyle(this.popup).transitionDuration) * 1000 || 600;
      setTimeout(() => {
        this.setActiveKeywordMobile(keyword);
        requestAnimationFrame(() => this.scrollKeywordIntoView(keyword));
        this.positionCloseButton();
      }, duration + 30);
    }

    closePopup() {
      if (!this.popup || !this.isMobile) return;
      this.popup.classList.remove("active");
      if (this.overlay) this.overlay.classList.remove("active");
      if (this.closeBtn) this.closeBtn.classList.remove("active");
      const duration = parseFloat(getComputedStyle(this.popup).transitionDuration) * 1000 || 600;
      setTimeout(() => { document.body.style.overflow = ""; }, duration);
    }

    setActiveKeywordDesktop(keyword) {
      this.querySelectorAll(".ai-keyword-item").forEach(item =>
        item.classList.toggle("active", item.dataset.keyword === keyword)
      );
    }

    setActiveKeywordMobile(keyword) {
      const items = [...this.querySelectorAll(".ai-keyword-item"),
                     ...this.querySelectorAll(".ai-popup .ai-keyword-item")];
      items.forEach(item => item.classList.toggle("active", item.dataset.keyword === keyword));
    }

    scrollKeywordIntoView(keyword) {
      if (!this.isMobile) return;
      const container = this.querySelector(".ai-popup-keywords");
      if (!container) return;

      const item = container.querySelector(`.ai-keyword-item[data-keyword="${CSS.escape(keyword)}"]`);
      if (!item) return;

      const containerRect = container.getBoundingClientRect();
      const itemRect = item.getBoundingClientRect();
      const scrollLeft = container.scrollLeft + (itemRect.left - containerRect.left) - container.clientWidth / 2 + item.clientWidth / 2;
      container.scrollTo({ left: scrollLeft, behavior: "smooth" });

      const popupRect = this.popup.getBoundingClientRect();
      const keywordsRect = container.getBoundingClientRect();

      if (keywordsRect.top < popupRect.top || keywordsRect.bottom > popupRect.bottom) {
        this.popup.scrollTo({ top: this.popup.scrollTop + (keywordsRect.top - popupRect.top) - 10, behavior: "smooth" });
      }
    }

    positionCloseButton() {
      if (!this.popup || !this.closeBtn) return;
      const popupRect = this.popup.getBoundingClientRect();
      this.closeBtn.style.bottom = `${window.innerHeight - popupRect.top + 10}px`;
    }
  }

  customElements.define("ai-review-summary-keyword", AIReviewSummaryKeyword);
}